import React from "react";
import { useTranslation } from "react-i18next";
import { TextSection } from "../../components/expretise/TextSection";
import DomainesIntervention from "../../components/expretise/DomainesIntervention";
import SlideGenerale from "../../components/expretise/slideGenarale";
import SEO from "../../components/SEO";
import img from "../../assets/images/Technologique.png";
import text from "../../assets/images/Technologique-text.png";
import { CercleIcon } from "../../assets/icons/CercleIcon";
import { Parametre } from "../../assets/icons/Parametre";
import { CardIcon } from "../../assets/icons/CardIcon";

export const Technologique = () => {
  const { t } = useTranslation();

  const cards = [
    {
      id: 1,
      icon: <CardIcon />,
      title: t("technologique.cards.strategique.title"),
      description: t("technologique.cards.strategique.description"),
      backContent: [
        t("technologique.cards.strategique.details.0"),
        t("technologique.cards.strategique.details.1"),
        t("technologique.cards.strategique.details.2"),
        t("technologique.cards.strategique.details.3"),
      ],
    },
    {
      id: 2,
      icon: <CercleIcon />,
      title: t("technologique.cards.bi.title"),
      description: t("technologique.cards.bi.description"),
      backContent: [
        t("technologique.cards.bi.details.0"),
        t("technologique.cards.bi.details.1"),
        t("technologique.cards.bi.details.2"),
        t("technologique.cards.bi.details.3"),
      ],
    },
    {
      id: 3,
      icon: <Parametre />,
      title: t("technologique.cards.decisionnelle.title"),
      description: t("technologique.cards.decisionnelle.description"),
      backContent: [
        t("technologique.cards.decisionnelle.details.0"),
        t("technologique.cards.decisionnelle.details.1"),
        t("technologique.cards.decisionnelle.details.2"),
        t("technologique.cards.decisionnelle.details.3"),
      ],
    },
    {
      id: 4,
      icon: <CardIcon />,
      title: t("technologique.cards.architecture.title"),
      description: t("technologique.cards.architecture.description"),
      backContent: [
        t("technologique.cards.architecture.details.0"),
        t("technologique.cards.architecture.details.1"),
        t("technologique.cards.architecture.details.2"),
        t("technologique.cards.architecture.details.3"),
      ],
    },
    {
      id: 5,
      icon: <CercleIcon />,
      title: t("technologique.cards.projets.title"),
      description: t("technologique.cards.projets.description"),
      backContent: [
        t("technologique.cards.projets.details.0"),
        t("technologique.cards.projets.details.1"),
        t("technologique.cards.projets.details.2"),
      ],
    },
    {
      id: 6,
      icon: <Parametre />,
      title: t("technologique.cards.transformation.title"),
      description: t("technologique.cards.transformation.description"),
      backContent: [
        t("technologique.cards.transformation.details.0"),
        t("technologique.cards.transformation.details.1"),
        t("technologique.cards.transformation.details.2"),
        t("technologique.cards.transformation.details.3"),
      ],
    },
  ];

  return (
    <div>
      <SEO
        title="MSIT Conseil - Conseil Technologique et Data"
        description="MSIT Conseil offre des services de conseil technologique, architecture de données, business intelligence et transformation digitale pour optimiser vos systèmes d'information."
        keywords="conseil technologique, architecture données, business intelligence, MSIT conseil, transformation digitale"
        url="https://www.msit-conseil.fr/bu-msit-conseil"
        breadcrumbs={[
          { name: "Accueil", url: "https://www.msit-conseil.fr/" },
          { name: "MSIT Conseil", url: "https://www.msit-conseil.fr/bu-msit-conseil" }
        ]}
      />
      <SlideGenerale
        headerBg="bg-dark"
        bgColor="bg-primary"
        sectionClass="consulting-section"
        heightBg={"consulting-section-height"}
        bgImage={img}
        infos={[
          {
            label: t("technologique.slide.infos.0.label"),
            value: t("technologique.slide.infos.0.value"),
          },
          {
            label: t("technologique.slide.infos.1.label"),
            value: t("technologique.slide.infos.1.value"),
          },
          {
            label: t("technologique.slide.infos.2.label"),
            value: t("technologique.slide.infos.2.value"),
          },
        ]}
        title={t("technologique.slide.title")}
        description={t("technologique.slide.description")}
      />
      <TextSection image={text} />
      <DomainesIntervention cards={cards} />
    </div>
  );
};
